import React from "react";
import { IOrderItem, IOrderItemParent } from "../constants";
import Styles from "../../../scss/orderDetails.module.scss";
import { ReactComponent as RefundSVG } from "../../../assets/images/icon-refund-square.svg"
import useFormatCurrency from "../../../yoello-lib/modules/localisation/useCurrency";
import InfoCard from "./InfoCard";
import { useTranslation } from "react-i18next";


interface IOrdermainDetailsProps extends IOrderItemParent {
    main: IOrderItem;
    isPartiallyRefundedItem?: boolean;
    isRefundedOrder?: boolean;
    isSquare: boolean;
    hasDiscountCode: boolean;
}



export function OrderItemDetails({ main, extras, isPartiallyRefundedItem, isSquare, hasDiscountCode , isRefundedOrder }: IOrdermainDetailsProps) {
    const { t } = useTranslation();
    const { formatCurrency } = useFormatCurrency();
    const preferences = main.in_order_item_preferences ?? [];

    function calculatePrice(item: IOrderItem){
        if(isPartiallyRefundedItem){
            if(item.in_order_item_discount_code_price){
                return item.in_order_item_discount_code_price * item.in_order_group_quantity_refunded 
            }else{
                return item.in_order_item_discount_price * item.in_order_group_quantity_refunded
            }

        }else{
            if(item.in_order_item_discount_code_price){
                return item.in_order_item_discount_code_price * (isRefundedOrder ? item.in_order_group_quantity :item.in_order_group_quantity - item.in_order_group_quantity_refunded) 
            }else{
                return item.in_order_item_discount_price * item.in_order_group_quantity
            }
        }
    }
    function calculateQuantity(item: IOrderItem){
        return isPartiallyRefundedItem ? item.in_order_group_quantity_refunded : isRefundedOrder ? item.in_order_group_quantity :item.in_order_group_quantity - item.in_order_group_quantity_refunded
    }
    function roundPercentage(num:number){
        return Math.round((num + Number.EPSILON) * 100) / 100
    }
    return <div className={isPartiallyRefundedItem ? Styles.partialRefundedItemWrapper : undefined}>
        {isPartiallyRefundedItem && <div className={Styles.partialRefundSvgWrapper}><RefundSVG /> <p>{t("PartialReafund.Refunded")}</p> </div>}
        <div className={!hasDiscountCode ?  Styles.PriceDetaileWrapper:undefined} >
            <div><p>{main.menu_item_name_public}</p></div>
            <div className={Styles.PriceDetails}>
                {
                    hasDiscountCode ? <>
                        <InfoCard label={t("orderHistory.modal.OriginalPrice")} value={formatCurrency(main.in_order_item_selling_price)} className={Styles.label} />
                        {!isSquare && <InfoCard label={t("orderHistory.modal.discounted")} value={main.in_order_item_discount_code_amount > 0 && <span style={{ color: "#FB3449" }}>
                            -{formatCurrency(main.in_order_item_discount_code_amount)} ({roundPercentage(main.in_order_item_discount_code_percentage)}%)
                        </span>} className={Styles.label} />}
                        <InfoCard label={t("orderHistory.modal.FinalPrice")} value={formatCurrency(main.in_order_item_discount_code_price)} className={Styles.label} />
                    </> :
                        <InfoCard label={t("orderHistory.modal.price")} value={formatCurrency(main.in_order_item_discount_code_price??main.in_order_item_discount_price)} className={Styles.label} />
                }
                <InfoCard label={t("orderHistory.modal.Quantity")} value={calculateQuantity(main)} className={Styles.label} />
                <InfoCard label={t("orderHistory.modal.Total")}
                    value={formatCurrency(calculatePrice(main))}
                    className={Styles.label} />
            </div>
            {preferences.length > 0 && <div>
                <div><p className={Styles.PrefAndExtrasTitle}>{t("orderHistory.modal.prefs")}</p></div>
                <div className={Styles.Preferences}>
                    <ul>
                        {preferences.map((pref) => <li> <p>{pref}</p> </li>)}
                    </ul>
                </div>
            </div>}
            {extras.length > 0 && <div style={{ gridColumn: '1/3' }}>
                <div><p className={Styles.PrefAndExtrasTitle}>{t("orderHistory.modal.extras")}</p></div>
                <div className={Styles.Extras}>
                    <ul>
                        {extras.map((extra) => <li className={!hasDiscountCode ? Styles.ExtrasPriceDetailsWrapper:undefined}>
                            <div>
                                <p>{extra.menu_item_name_public}</p>
                            </div>
                            <div>
                                {hasDiscountCode && <>
                                    <p>{formatCurrency(extra.in_order_item_selling_price)}</p>
                                    {!isSquare && <p style={{ color: "#FB3449", width:"100px"}}>
                                        {extra.in_order_item_discount_code_amount > 0 && <>-{formatCurrency(extra.in_order_item_discount_code_amount)} ({roundPercentage(extra.in_order_item_discount_code_percentage)}%)</>}
                                    </p>}
                                </>}
                                <p>{formatCurrency(extra.in_order_item_discount_code_price??extra.in_order_item_discount_price)}</p>
                                <p>{calculateQuantity(extra)}</p>
                                <p>{formatCurrency(calculatePrice(extra))}</p>
                            </div>
                        </li>
                        )}
                    </ul>
                </div>
            </div>}
        </div>
    </div>
}